<template>
    <div>
        <pc-alert v-bind="alertBinder">
            <div class="flex-grow-1">
                <div class="mb-3 fw-bold">
                    {{ upgradeSummary }}
                </div>
                <div v-if="hasFailures">
                    <div
                        v-if="canDownloadResults"
                        class="mb-3">
                        <pc-button v-on:click="downloadFile(resultsDownloadUrl)">
                            {{ downloadButtonLabel }}
                        </pc-button>
                    </div>
                    <div class="mb-3">
                        {{ upgradeWarning }}
                    </div>
                    <div
                        v-for="result in failureResults"
                        v-bind:key="result.CreateTagsResultModel.TemplateId"
                        class="mb-3">
                        <tag-errors
                            v-bind:create-tags-result-model="result.CreateTagsResultModel"
                            show-template-name
                            use-collapsed-view
                            v-on:template-name-click="onTemplateNameClicked" />
                        <hr />
                    </div>
                </div>
            </div>
        </pc-alert>
    </div>
</template>
<script>
    import tagErrors from "./tagErrors.vue";
    import { ALERT_SEVERITY } from "Util/alerts";
    import { downloadFile } from "Util/util";
    import { KEYS, NAMESPACE } from "./i18n/bulkUpgradeResults.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        components: {
            tagErrors
        },
        props: {
            /** Array of objects implementing IUpgradeResultClientModel */
            upgradeResults: { type: Array, required: false, default: () => [] },
            analyzeOnly: { type: Boolean, required: false, default: false },
            resultsDownloadUrl: { type: String, required: false, default: null }
        },
        emits: ["template-name-click"],
        data() {
            return {};
        },
        computed: {
            upgradeSummary() {
                const failCount = this.failureResults.length;
                const totalCount = this.upgradeResults.length;
                const successCount = totalCount - failCount;

                const successStr = this.analyzeOnly
                    ? this.$app.res({
                          namespace: NAMESPACE,
                          key: KEYS.analysisResultsMessage,
                          values: {
                              successCount: successCount,
                              totalCount: totalCount
                          }
                      })
                    : this.$app.res({
                          namespace: NAMESPACE,
                          key: KEYS.upgradeResultsMessage,
                          values: {
                              successCount: successCount,
                              totalCount: totalCount
                          }
                      });
                const failStr =
                    failCount > 0
                        ? this.$app.res({
                              namespace: NAMESPACE,
                              key: KEYS.failureResultMessage,
                              values: {
                                  failCount: failCount
                              }
                          })
                        : "";

                return successStr + failStr;
            },
            hasFailures() {
                return this.failureResults.length > 0;
            },
            failureResults() {
                return this.upgradeResults.filter((result) => {
                    return !result.Success;
                });
            },
            canDownloadResults() {
                return Boolean(this.resultsDownloadUrl);
            },
            alertBinder() {
                const title = this.analyzeOnly
                    ? this.analysisTitle
                    : this.hasFailures
                      ? this.failuresTitle
                      : this.successTitle;
                const severity = this.analyzeOnly
                    ? ALERT_SEVERITY.info
                    : this.hasFailures
                      ? ALERT_SEVERITY.warning
                      : ALERT_SEVERITY.success;

                return {
                    title: title,
                    severity: severity,
                    shown: true
                };
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            onTemplateNameClicked(data) {
                this.$emit("template-name-click", data);
            },
            downloadFile
        }
    };
</script>
